Ext.define('SA.view.newproject.VariablesWindow', {
    alias: 'widget.new-project-variables-window',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-new-project-window sa-new-project-variables-window',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    items: [
        {
            xtype: 'close-button',
            closeAction: 'onCloseClick'
        }, {
            xtype: 'component',
            cls: 'sa-new-project-variables-window-instruction',
            margin: '42 32 0',

            html: [
                '<p>',
                    'Please select one or more “seed” variables so we can auto-generate maps and reports for you.',
                '</p>',
                '<aside>',
                    '(Thousands of other data variables are available. Use the ‘Data’ tab to search and add them to your project.)',
                '</aside>'
            ]
        }, {
            xtype: 'new-project-variables-list',
            itemId: 'list'
        }, {
            xtype: 'simple-container',
            cls: 'sa-new-project-window-footer',

            items: [
                {
                    xtype: 'sa-button',
                    autoEl: 'button',
                    text: 'Create project',
                    ui: 'primary',
                    width: 118,

                    handler() {
                        this.up('new-project-variables-window').onCreateProjectClick();
                    }
                }, {
                    xtype: 'component',
                    autoEl: 'button',
                    cls: 'sa-new-project-variables-window-skip-variables-link',
                    html: 'Create project without seed variables',
                    itemId: 'skipVariablesLink'
                }
            ]
        }
    ],

    afterRender() {
        this.callParent();

        this.down('close-button').el.focus();
    },

    initComponent() {
        this.callParent();

        this.ifCls(this.wide, 'sa-new-project-variables-window-wide');

        this.setListData();
    },

    initEvents() {
        this.callParent();

        this.down('#skipVariablesLink').el.on('click', this.onSkipVariablesClick, this);
    },

    onCloseClick() {
        this.fireEvent('click:close');
    },

    onCreateProjectClick() {
        var selection = this.down('#list').getSelectedAttributes();

        this.triggerDone(selection);
    },

    onSkipVariablesClick(ev) {
        ev.preventDefault();

        this.triggerDone([]);
    },

    setListData() {
        var list = this.down('#list'),
            variables = this.variables;

        list.data = variables.map(item => {
            return {
                attribute: item.attribute,
                name: getName(item),
                selected: item.isDefault
            };
        });

        function getName(variable) {
            var name = variable.name,
                currentYearAttributeSeries = ['DEMEST->???baspop', 'DEMEST->???bashhd'];

            if (currentYearAttributeSeries.includes(variable.attributeSeries)) {
                name += ' (Current Year)';
            }

            return name;
        }
    },

    triggerDone(selection) {
        this.fireEvent('done', selection);
    }
});
